import { useCallback } from 'react';
import { Flex } from 'foundations-components/components/Flex';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getRecipientNameCHIRP } from '../../../utils/getRecipientName';
import { ContactAvatarCHIRP } from '../../ContactAvatarCHIRP';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SummaryRecipientsContactCellCHIRP = ({
  documentVisitor,
  onViewDetails
}) => {
  const handleClick = useCallback(e => {
    e.stopPropagation();
    onViewDetails(documentVisitor);
  }, [onViewDetails, documentVisitor]);
  const name = documentVisitor !== null && documentVisitor !== void 0 && documentVisitor.contact ? getRecipientNameCHIRP(documentVisitor === null || documentVisitor === void 0 ? void 0 : documentVisitor.contact) : '';
  return /*#__PURE__*/_jsx(TableHoverCell, {
    hoverContent: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(Button, {
        size: "extra-small",
        use: "tertiary-light",
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.recipientsTable.row.viewDetails"
        })
      })
    }),
    children: /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "300",
      children: [/*#__PURE__*/_jsx(ContactAvatarCHIRP, {
        contact: documentVisitor === null || documentVisitor === void 0 ? void 0 : documentVisitor.contact
      }), name]
    })
  });
};